import lboIcon from 'assets/images/lbo.svg';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import TextField from '../../../components/common/TextField';
import { checkShopId, checkShopIdLive } from '../../../modules/validators';
import { submitShopId } from '../actions';

export class EnterShopId extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      shopId: '',
      validationErrors: [],
      submitDisabled: true
    };
  }

  handleChange(event) {
    const value = event.target.value.toString();

    const errors = checkShopIdLive(value);
    const submitDisabled = checkShopId(value).length !== 0;

    this.setState({
      shopId: value,
      validationErrors: (errors.length) ? [errors[0]] : [],
      submitDisabled
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { shopId } = this.state;

    this.props.submit(shopId);
  }

  render() {
    const { submitDisabled, validationErrors } = this.state;

    return (
      <div className="enter-shop-id container--fixed">
        <img src={lboIcon} className="enter-shop-id__icon" />
        <h1 className="enter-shop-id__header">Enter your LBO Number</h1>
        <p className="enter-shop-id__text">
          Enter your 6 digit LBO number below to ensure PLUS sign-ups are tracked correctly
        </p>
        <form className="enter-shop-id__form" onSubmit={this.handleSubmit}>
          <TextField
            id="lbo-number"
            className="enter-shop-id__input"
            maxLength={6}
            type="tel"
            onChange={this.handleChange}
            errors={validationErrors}
            hintText="e.g. 123456"
          />
          <Button
            className="enter-shop-id__button"
            onClick={this.handleSubmit}
            disabled={submitDisabled}
          >
            Continue
          </Button>
        </form>
      </div>
    );
  }
}

EnterShopId.propTypes = {
  submit: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  submit: submitShopId
};

export default connect(null, mapDispatchToProps)(EnterShopId);
